module.exports = __webpack_public_path__ + "octicons.svg?190e72572ee84190f4777765fa49fc47";


/*****************
 ** WEBPACK FOOTER
 ** ./~/octicons/build/font/octicons.svg?ef21c39f0ca9b1b5116e5eb7ac5eabe6
 ** module id = 122
 ** module chunks = 0
 **/